import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:id`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/${id}`;
